<template>
    <div class="property-saved-searches-card-header d-flex align-items-center justify-content-between">
                <h2>
                    {{ propertySearchFilterAppResource.name }}
                </h2>
                <b-button
                        class="close-button"
                        variant="link"
                        @click.stop="deleteSavedSearch"
                >
                    <i class="fal fa-times" />
                </b-button>
    </div>
</template>

<script>
    import './PropertySavedSearchesCardHeader.scss';
    import PropertySearchFilterAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/PropertySearchFilterAppResource";
    import ShowNotificationMixin from '@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin';
    import {DELETE_SAVED_SEARCH_MODAL_DISPLAY} from "../../DeleteSavedSearchModal/DeleteSavedSearchModal";

    export const PROPERTY_SAVED_SEARCHES_CARD_HEADER_DELETE = 'PropertySavedSearchesCardHeader:delete';

    export default {
        name: "PropertySavedSearchesCardHeader",

        mixins: [ShowNotificationMixin],

        props: {
            propertySearchFilterAppResource: {
                type: PropertySearchFilterAppResource,
                required: true,
            }
        },

        methods: {
            async deleteSavedSearch() {
                this.$bus.$emit(DELETE_SAVED_SEARCH_MODAL_DISPLAY, {
                    entity: this.propertySearchFilterAppResource
                });
            },
        },
    };
</script>
